var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-container',[_c('view-title',{attrs:{"title":"My Games"}}),_c('active-games'),_c('hr'),_c('spectating-games'),_c('completed-games')],1)}
var staticRenderFns = []

export { render, staticRenderFns }